import { render, staticRenderFns } from "./HomePageV2.vue?vue&type=template&id=9cc966f2&scoped=true&"
import script from "./HomePageV2.vue?vue&type=script&lang=js&"
export * from "./HomePageV2.vue?vue&type=script&lang=js&"
import style0 from "./HomePageV2.vue?vue&type=style&index=0&id=9cc966f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc966f2",
  null
  
)

export default component.exports